import React, { Dispatch, SetStateAction } from 'react';
import {
  RecurrentModalProps,
  setRecurrentModalStorage,
} from 'hooks/useRecurrentModal';
import Modal2 from 'components/commons/modal/Modal2';
import { getRecurrentModalStorage, ModalID } from '../RecurrentModal';

export const DividendQuestionaryModal = ({
  isShow,
  isNotShowAgain,
  setIsNotShowAgain,
  goReview,
  showLater,
  modalID,
}: {
  isShow: boolean;
  isNotShowAgain: boolean;
  setIsNotShowAgain: Dispatch<SetStateAction<boolean>>;
  goReview: () => void;
  showLater: () => void;
  modalID: ModalID;
}) => {
  const {
    recurrentModal,
    targetRecurrentModal,
    otherRecurrentModal,
  } = getRecurrentModalStorage('dividendQuestionary');

  const newRecurrentModal = {
    id: modalID,
    readDay: null,
    hidden: false,
  } as RecurrentModalProps;

  if (recurrentModal === null || recurrentModal === undefined) {
    setRecurrentModalStorage([newRecurrentModal]);
  }

  if (
    recurrentModal !== null &&
    targetRecurrentModal === undefined &&
    otherRecurrentModal
  ) {
    const newRecurrentModalStorage = recurrentModal.concat(newRecurrentModal);
    setRecurrentModalStorage(newRecurrentModalStorage);
  }

  return (
    <Modal2 isShow={isShow} modalBaseClass={'lg:w-400p'}>
      <div className="max-h-modal overflow-y-auto text-bluegray-700">
        <div className="w-full h-full">
          <img
            src="/static/images/modal/dividend_questionary.svg"
            alt=""
            className="w-full h-full"
            style={{ objectFit: 'cover' }}
          />
        </div>
        <div
          className="px-4 pt-4 pb-4 sticky bg-white shadow-lg"
          style={{ bottom: '0%', left: '0%' }}>
          <div className="text-base font-bold text-center">
            <div className="flex items-end justify-center lg:mb-auto app-primary-label-block">
              <div className="inline-flex items-center flex-col lg:flex-row text-bluegray-700 font-bold">
                アイデア大募集
              </div>
            </div>
            あなたの声で配当管理が変わる！
          </div>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScNOiGpye5vJOOF8zd43Ucv2jsQHwo1LgFUJdD_Yh1LdPLOyw/viewform"
            target="_blank"
            rel="noopener noreferrer">
            <div
              className="mt-4 py-2 px-4 flex flex-row items-center justify-center text-white text-base font-bold bg-blue-700 rounded-lg cursor-pointer"
              onClick={(): void => goReview()}>
              アンケートに答える
            </div>
          </a>
          <div className="mt-4 py-2 px-4 flex flex-row items-center justify-center text-sm text-bluegray-500 rounded-lg">
            <div className="cursor-pointer" onClick={(): void => showLater()}>
              あとで
            </div>
          </div>
          <div className="mt-2 py-2 px-4 text-xs text-bluegray-500 rounded-lg">
            <div
              className="flex flex-row items-center justify-center cursor-pointer"
              onClick={(): void => setIsNotShowAgain(prev => !prev)}>
              <div
                className={`icon-check text-white mr-2 rounded-sm ${
                  isNotShowAgain ? 'bg-blue-700' : 'bg-bluegray-300'
                }`}></div>
              今後表示しない
            </div>
          </div>
        </div>
      </div>
    </Modal2>
  );
};
